import styled from "styled-components";

export const ConfigureContainer = styled.div`
  text-align: right;
`;
